import React, { useState, useEffect } from 'react';
import { JobSource, FormErrors } from '../types';
import ImageUploader from '../shared/ImageUploader';

interface MediaSectionProps {
  formData: JobSource;
  setFormData: React.Dispatch<React.SetStateAction<JobSource>>;
  errors: FormErrors;
  onLogoFileChange?: (file: File | null) => void;
  onThumbnailFileChange?: (file: File | null) => void;
}

const MediaSection: React.FC<MediaSectionProps> = ({
  formData,
  setFormData,
  errors,
  onLogoFileChange,
  onThumbnailFileChange,
}) => {
  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [logoPreview, setLogoPreview] = useState<string | null>(formData.logo_url || null);
  const [thumbnailFile, setThumbnailFile] = useState<File | null>(null);
  const [thumbnailPreview, setThumbnailPreview] = useState<string | null>(formData.thumbnail_url || null);

  useEffect(() => {
    if (formData.logo_url) {
      setLogoPreview(formData.logo_url);
    }
  }, [formData.logo_url]);

  useEffect(() => {
    if (formData.thumbnail_url) {
      setThumbnailPreview(formData.thumbnail_url);
    }
  }, [formData.thumbnail_url]);

  const handleLogoChange = (file: File | null, preview: string | null) => {
    setLogoFile(file);
    setLogoPreview(preview);
    if (onLogoFileChange) {
      onLogoFileChange(file);
    }
  };

  const handleThumbnailChange = (file: File | null, preview: string | null) => {
    setThumbnailFile(file);
    setThumbnailPreview(preview);
    if (onThumbnailFileChange) {
      onThumbnailFileChange(file);
    }
  };

  return (
    <div className="tab-pane active">
      <div className="row">
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label fw-semibold">ロゴ画像</label>
            <div className="mb-2">
              <a
                href="https://docs.google.com/presentation/d/1GwjSnuHt5YMcf9pkpHq1o-DGrAcnzVocy8GUULKNe0s/edit?slide=id.g33fb8d3be0a_1_6#slide=id.g33fb8d3be0a_1_6"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary text-decoration-none"
              >
                こちらから作成してください
              </a>
            </div>
          </div>
          <ImageUploader
            label=""
            currentPreview={logoPreview}
            file={logoFile}
            onChange={handleLogoChange}
            name="logo"
            errors={errors.logo}
          />
        </div>
        <div className="col-md-6">
          <ImageUploader
            label="サムネイル画像"
            currentPreview={thumbnailPreview}
            file={thumbnailFile}
            onChange={handleThumbnailChange}
            name="thumbnail"
            errors={errors.thumbnail}
          />
        </div>
      </div>
    </div>
  );
};

export default MediaSection;

